import { ORDER_BY, SF_INVOICE_CONSTANTS } from "common/sf_strings"
import _ from "lodash"
import { buildCampaignAnalysisCacheKey as buildPaginationCacheKey } from "helpers/sf_utils"
import {
  GET_INVOICES_BY_ADMIN,
  GET_INVOICES_BY_ADMIN_SUCCESS,
  GET_INVOICES_BY_ADMIN_ERROR,
  UPDATE_INVOICE_BY_ADMIN,
  UPDATE_INVOICE_BY_ADMIN_SUCCESS,
  UPDATE_INVOICE_BY_ADMIN_ERROR,
  CREATE_RECEIPT_BY_ADMIN,
  CREATE_RECEIPT_BY_ADMIN_SUCCESS,
  CREATE_RECEIPT_BY_ADMIN_ERROR,
  GET_BILLING_REPORT_BY_ADMIN,
  GET_BILLING_REPORT_BY_ADMIN_SUCCESS,
  GET_BILLING_REPORT_BY_ADMIN_ERROR,
  DELETE_INVOICE_BY_ADMIN,
  DELETE_INVOICE_BY_ADMIN_SUCCESS,
  DELETE_INVOICE_BY_ADMIN_ERROR,
  EDIT_INVOICE_BY_ADMIN,
  EDIT_INVOICE_BY_ADMIN_SUCCESS,
  EDIT_INVOICE_BY_ADMIN_ERROR,
  GET_INVOICE_EVENTS_BY_ID,
  GET_INVOICE_EVENTS_BY_ID_SUCCESS,
  GET_INVOICE_EVENTS_BY_ID_ERROR,
  RESET_INVOICE_EVENTS_BY_ID,
  RESET_ERROR,
  RESET_RECEIPT_TERMINAL_FORM,
  GET_RECEIPTS_INFO_BY_ADMIN,
  GET_RECEIPTS_INFO_BY_ADMIN_SUCCESS,
  GET_RECEIPTS_INFO_BY_ADMIN_ERROR
} from "./actionTypes"

const INIT_STATE = {
  admin_invoices: [],
  admin_receipts: [],
  error: null,
  error_receipt_logs: null,
  loading: false,
  loading_receipts: false,
  loading_get_receipts: false,
  loading_report_by_admin: false,
  updating_card_by_admin: false,
  is_clear_form_data: false,
  last_page_fetched: 0,
  total_number_of_pages: 0,
  receipts_active_cache_key: null,
  receipts_page_cache: {},
}
const AdminInvoices = (state = INIT_STATE, action) => {
  switch (action.type) {
    case RESET_ERROR:
      return {
        ...state,
        error: null,
      }
    case GET_RECEIPTS_INFO_BY_ADMIN: {
      const page_number = action.paginated ? (action.payload.queryParams.page_number || 1) : 1
      const useCache = Boolean(action.payload?.useCache)
      const queryParams = action.payload?.queryParams || {}
      const cacheKey = useCache ? buildPaginationCacheKey(queryParams) : null
      const shouldResetCache =
        useCache &&
        page_number === 1 &&
        state.receipts_active_cache_key &&
        state.receipts_active_cache_key !== cacheKey
      const cachedPage = useCache ? state.receipts_page_cache?.[cacheKey]?.[page_number] : null

      return {
        ...state,
        error_receipt_logs: null,
        loading_get_receipts: !cachedPage,
        receipts_active_cache_key: useCache ? cacheKey : null,
        admin_receipts: cachedPage?.rows || ((page_number === 1) ? [] : state.admin_receipts),
        last_page_fetched: cachedPage?.page_number ?? state.last_page_fetched,
        total_number_of_pages: cachedPage?.total_number_of_pages ?? state.total_number_of_pages,
        receipts_page_cache: shouldResetCache ? {} : state.receipts_page_cache,
      }
    }

    case GET_RECEIPTS_INFO_BY_ADMIN_SUCCESS: {
      const rows = action.payload.data || []
      const additional = action.payload.additional_data || {}
      const useCache = Boolean(action.meta?.useCache)
      const cacheKey = useCache ? buildPaginationCacheKey(action.meta?.queryParams || {}) : null
      const pageNum = parseInt(additional.page_number, 10)
      const totalPages = parseInt(additional.total_number_of_pages, 10)
      const safePage = Number.isFinite(pageNum) && pageNum > 0 ? pageNum : 1
      const safeTotal = Number.isFinite(totalPages) && totalPages >= 0 ? totalPages : 0
      const pageSnapshot = { rows, page_number: safePage, total_number_of_pages: safeTotal }

      return {
        ...state,
        admin_receipts: rows,
        last_page_fetched: safePage,
        total_number_of_pages: safeTotal,
        loading_get_receipts: false,
        error_receipt_logs: null,
        receipts_active_cache_key: useCache ? cacheKey : state.receipts_active_cache_key,
        receipts_page_cache: useCache ? {
          ...state.receipts_page_cache,
          [cacheKey]: {
            ...(state.receipts_page_cache?.[cacheKey] || {}),
            [safePage]: pageSnapshot,
          },
        } : state.receipts_page_cache,
      }
    }

    case GET_RECEIPTS_INFO_BY_ADMIN_ERROR:
      return {
        ...state,
        error_receipt_logs: action.payload,
        loading_get_receipts: false,
      }

    case GET_INVOICES_BY_ADMIN:
      return {
        ...state,
        error: null,
        loading: true,
      }

    case GET_INVOICES_BY_ADMIN_SUCCESS:
      return {
        ...state,
        error: null,
        admin_invoices: action.payload,
        loading: false,
      }

    case GET_INVOICES_BY_ADMIN_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
      }

    case UPDATE_INVOICE_BY_ADMIN:
      return {
        ...state,
        error: null,
        loading: true,
      }

    case UPDATE_INVOICE_BY_ADMIN_SUCCESS:
      return {
        ...state,
        error: null,
        admin_invoices: [...state.admin_invoices.map((invoice) => (invoice.id == action.payload.id
          ? ({ ...invoice, ...action.payload }) : invoice))],
        loading: false,
      }

    case UPDATE_INVOICE_BY_ADMIN_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
      }

    case CREATE_RECEIPT_BY_ADMIN:
      return {
        ...state,
        error: null,
        loading_receipts: true,
        is_clear_form_data: false
      }

    case CREATE_RECEIPT_BY_ADMIN_SUCCESS:
      return {
        ...state,
        error: null,
        loading_receipts: false,
        is_clear_form_data: true,
        // New receipt shifts pagination; invalidate so all pages refetch fresh
        receipts_page_cache: {},
      }

    case CREATE_RECEIPT_BY_ADMIN_ERROR:
      return {
        ...state,
        error: action.payload,
        loading_receipts: false,
      }

    case GET_BILLING_REPORT_BY_ADMIN:
      return {
        ...state,
        error: null,
        loading_report_by_admin: true,
        updating_card_by_admin: false,

      };

    case GET_BILLING_REPORT_BY_ADMIN_SUCCESS:
      return {
        ...state,
        error: null,
        loading_report_by_admin: false,
        updating_card_by_admin: false,

      };

    case GET_BILLING_REPORT_BY_ADMIN_ERROR:
      return {
        ...state,
        error: action.payload,
        loading_report_by_admin: false,
        updating_card_by_admin: false,

      };

    case DELETE_INVOICE_BY_ADMIN:
      return {
        ...state,
        error: null,
        loading: true,
      };

    case DELETE_INVOICE_BY_ADMIN_SUCCESS:
      return {
        admin_invoices: state.admin_invoices.filter(invoice => invoice.id != action.payload.id),
        error: null,
        loading: false,
      };

    case DELETE_INVOICE_BY_ADMIN_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };

    case EDIT_INVOICE_BY_ADMIN:
      return {
        ...state,
        error: null,
        loading: true,
      };

    case EDIT_INVOICE_BY_ADMIN_SUCCESS:
      return {
        admin_invoices: state.admin_invoices.map(invoice => invoice.id == action.payload.id ? ({ ...invoice, ...action.payload }) : invoice),
        error: null,
        loading: false,
      };

    case EDIT_INVOICE_BY_ADMIN_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };

    case RESET_RECEIPT_TERMINAL_FORM:
      return {
        ...state,
        is_clear_form_data: false
      };

    default:
      return state
  }
}


const INIT_STATE_INVOICE_VERSION = {
  invoice_versions: [],
  loading: false,
  error: null,
};

const InvoiceVersion = (state = INIT_STATE_INVOICE_VERSION, action) => {
  switch (action.type) {
    case GET_INVOICE_EVENTS_BY_ID:
      return {
        ...state,
        loading: true
      };
    case GET_INVOICE_EVENTS_BY_ID_SUCCESS:
      return {
        invoice_versions: _.orderBy(action.payload, [SF_INVOICE_CONSTANTS.CREATED_AT], [ORDER_BY.DESC]).map((li_log, index) => ({ ...li_log, version_index: index })),
        loading: false
      };
    case GET_INVOICE_EVENTS_BY_ID_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    case RESET_INVOICE_EVENTS_BY_ID:
      return {
        ...state,
        loading: false,
        invoice_versions: [],
      };
    default:
      return state
  }
}

export { AdminInvoices, InvoiceVersion }